import Image from "next/image";
import Link from "next/link";
import { useLanguage } from "@/utils/LanguageContext";

import logo_1 from "@/assets/img/logo/logo.png";

const HeaderOffcanvas = ({ offCanvas, setOffCanvas }: any) => {
   const { lang } = useLanguage();
   return (
      <>
         <div className={`${offCanvas ? "offcanvas-menu-visible" : ""}`}>
            <div className={`extra-info ${offCanvas ? "active" : ""}`}>
               <div className="close-icon menu-close">
                  <button
                     onClick={() => setOffCanvas(false)}
                     aria-label="Close menu"
                  >
                     <i className="far fa-window-close"></i>
                  </button>
               </div>
               <div className="logo-side mb-30">
                  <Link href={`/${lang}/home`} prefetch={false}><Image src={logo_1} alt="Logo" /></Link>
               </div>
               <div className="side-info mb-30">
                  <div className="contact-list mb-30">
                     <h4>Office Address</h4>
                     <p>Lauriedstrasse 1, 6300<br /> Zug, Switzerland 1/8</p>
                  </div>
                  {/* <div className="contact-list mb-30">
                     <h4>Phone Number</h4>
                     <p>+0989 7876 9865 9</p>
                     <p>+(090) 8765 86543 85</p>
                  </div> */}
                  <div className="contact-list mb-30">
                     <h4>Email Address</h4>
                     <p>info@invtron.com</p>
           
                  </div>
               </div>
               <div className="social-icon-right mt-30">
                  <Link href="https://www.facebook.com/invtrondao" aria-label="Facebook">
                     <i className="fab fa-facebook-f"></i>
                  </Link>
                  <Link href="https://x.com/invtrondao" aria-label="X">
                     <i className="fab fa-twitter"></i>
                  </Link>
                  <Link href="https://www.linkedin.com/company/invtron-dao/" aria-label="LinkedIn">
                     <i className="fab fa-linkedin-in"></i>
                  </Link>
                  <Link href="https://www.instagram.com/invtron/" aria-label="Instagram">
                     <i className="fab fa-instagram"></i>
                  </Link>
               </div>
            </div>
            <div onClick={() => setOffCanvas(false)} className={`offcanvas-overly ${offCanvas ? "active" : ""}`}></div>
         </div>
      </>
   )
}

export default HeaderOffcanvas
